import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppLayout } from '../components/layout';
import { Card, Table, Button, Select } from '../components/ui';
import type { Column } from '../components/ui/Table';
import useProvidersStore, { Provider } from '../stores/providersStore';

const Providers = () => {
	const navigate = useNavigate();
	const providers = useProvidersStore(state => state.providers);
	const [selectedBusiness, setSelectedBusiness] = useState('all');

	const businesses = [
		{ label: 'All', value: 'all' },
		{ label: 'Trendit', value: 'trendit' },
		{ label: 'B4B', value: 'b4b' },
		{ label: '200Below', value: '200below' },
	];

	const columns: Column<Provider>[] = [
		{
			key: 'name',
			header: 'Name',
			sortable: true,
			render: (_, row) => (
				<div>
					<div className="font-semibold text-gray-900 dark:text-gray-100">{row.name}</div>
					<div className="text-sm text-gray-600 dark:text-gray-400">{row.specialty}</div>
				</div>
			),
		},
		{
			key: 'city',
			header: 'City',
			sortable: true,
		},
		{
			key: 'appointments',
			header: 'Total Appointments',
			sortable: true,
		},
		{
			key: 'revenue',
			header: 'Total Revenue',
			sortable: true,
			render: value => <span className="font-semibold text-blue-600 dark:text-blue-400">${value.toLocaleString()}</span>,
		},
	];

	return (
		<AppLayout
			topbarContent={
				<Select value={selectedBusiness} onChange={e => setSelectedBusiness(e.target.value)} className="min-w-[160px]">
					{businesses.map(biz => (
						<option key={biz.value} value={biz.value}>
							{biz.label}
						</option>
					))}
				</Select>
			}
		>
			<Card>
				<div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 mb-4">
					<h2 className="text-xl md:text-2xl font-bold text-gray-900 dark:text-gray-100 m-0">Providers</h2>
					<Button variant="primary" onClick={() => navigate('/providers/new')} className="w-full sm:w-auto">
						+ Add New Provider
					</Button>
				</div>

				<div className="overflow-x-auto -mx-[18px] px-[18px]">
					<Table data={providers} columns={columns} onRowClick={row => navigate(`/providers/${row.id}`)} />
				</div>
			</Card>

			<div className="mt-6 text-sm text-gray-500 dark:text-gray-400">© Beauty Business Portal</div>
		</AppLayout>
	);
};

export default Providers;
